import React, { FC, useState } from 'react';
import { useUniSelector } from '@lmt/unicorn-shared/app/store/types';
import { MeasuredValue } from '../../../features/measurements/types';
import { DXG } from '@lmt/unicorn-shared/app/common/devexpress/Grid/dx-grid';

interface Props {
  data: {
    value: string;
    setValue: (value: string) => void;
  };
}

const search = ['key', 'name'];

export const SourceAutocomplete: FC<Props> = (props: Props) => {
  const measuredValues = useUniSelector(
    (state) => state.measurement.measuredValues,
  );

  const [value, setValue] = useState<string>(props.data.value);

  const renderAutocompleteItem = (itemData: MeasuredValue) => {
    return <div>{`${itemData.key} ${itemData.name}`}</div>;
  };

  return (
    <DXG.Autocomplete
      dataSource={measuredValues}
      value={value}
      valueExpr="key"
      itemRender={renderAutocompleteItem}
      searchExpr={search}
      searchMode="contains"
      maxItemCount={100}
      onValueChanged={(e) => {
        setValue(e.value);
        props.data.setValue(e.value);
      }}
    />
  );
};
